import { Field as FieldPrimitive } from "@base-ui/react/field";
import { cva } from "cva";
import { cn } from "#ui-atoms/lib/utils";

const baseLabelVariants = cva({
  base: "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
});

export type BaseFieldLabelProps = FieldPrimitive.Label.Props;

export function BaseFieldLabel({ className, ...props }: BaseFieldLabelProps) {
  return (
    <FieldPrimitive.Label
      className={cn(baseLabelVariants({ className }), className)}
      data-slot="field-label"
      {...props}
    />
  );
}
